export type ThemeMode = "light" | "dark";

export const THEME_BACKGROUND_COLORS = {
    light: "#f7f8fa",
    dark: "#0b0d12",
} satisfies Record<ThemeMode, string>;
